export enum RecordState {
  None = 'None',
  NotParticipating = 'NotParticipating',
  Success = 'Success',
  Outbid = 'Outbid'
}
